<div class="col-sm-12 no-padding animated fadeIn">
    <h3>Listagem</h3>
    <hr>

    <div class="col-sm-12">
        
        <div class="col-sm-12 no-padding">
            <h4>Pesquisa:</h4>
            <div class="col-sm-6 no-padding">
                <div class="ui-g-10 ui-fluid" style="padding: 0;">
                
                    <label>Status da Proposta:</label>
                    <p-select name="status" [options]="listaStatus"
                        placeholder="Selecione" [filter]="true" 
                        [(ngModel)]="dispensaInegibilidadeFiltro.statusProposta"                                      
                         required></p-select>
                </div>
            </div>
            <br>
            <br>
            <div class="col-sm-12 no-padding">
                <hr>
            </div>
            
    
            <div class="col-sm-9 no-padding">
              
                <input type="text" class="form-control" [(ngModel)]="dispensaInegibilidadeFiltro.titulo" placeholder="Por nome da proposta" >
               
            </div>
              
            <div class="col-sm-3 no-padding">
               
                <button class="btn btn-primary btn-flat" (click)="pesquisarPropostaNome()" >Pesquisar</button>                <div class="checkbox" style="margin-top: 8px;">
                    <label class="checkbox-inline">
                        <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                        Manter filtros selecionados
                    </label>
                </div>
               
            </div>
        </div>
    </div>
    <div  class="col-sm-12" *ngIf="listaDispensaInegibilidade">

        <div class="box">
            <div class="box-header">
                <h3 class="box-title"></h3>
            </div>


            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <tbody>
                        <tr>
                            <th>Título da Proposta</th>
                            <th>Descrição</th>
                            <th>Status</th>
                            <th>Usuário</th>
                            <th class="text-center" style="min-width: 65px;">Ações</th>
                        </tr>

                        <tr *ngFor="let prop of listaDispensaInegibilidade">
                            <td>{{prop.titulo }}</td>
                            <td>{{ prop.descricao }}</td>
                            <td>{{ prop.statusProposta}}</td>
                            <td>{{ prop.usuario.nome }}</td>
                           
                            <td class="text-center">
                               <a  pTooltip="Analisar"> <i  class="fa fa-eye"
                                    style="cursor:pointer; color: grey; font-size: 20px;"></i>
                               </a>

                               <a  pTooltip="Editar"> <i  class="fa fa-edit"
                                style=" cursor:pointer;color: blue; font-size: 20px;"></i>
                               </a>
                               
                               
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination [page]="page" (paginationEvent)=changePage($event)></pagination>
            </div>
        </div>
    
       <hr>
   
</div>


</div>
